import { InjectionToken } from "@angular/core";
import { PreguntaExportador } from "@shared/clases/exportador";

export const PreguntaExportadorToken = new InjectionToken<PreguntaExportador>("PreguntaExportadorToken");
